// Widget Studio — definition catalog list (CHG-2471 / ITER-905213, S5).
//
// Platform-global, strictly READ-ONLY (POST /definitions is seed-only — no
// create). Config in @generated/screens/widget-definition-list, regenerated
// from widget-definition.entity-hint.yaml. Route /channels/widgets/catalog.

import { ListPage } from "../components/composition";
import { widgetDefinitionListConfig } from "../generated/screens/widget-definition-list";

export function WidgetCatalog() {
  return <ListPage config={widgetDefinitionListConfig} />;
}
